import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModalAction } from '../../../actions/modal';
import Form from '../../../common/Form';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import Input from '../../../common/Form/Input';
import RenderMilestones from '../components/RenderMileStones';
import scogo_apis from '../../../scogo_apis';
import { mapFaultyAsset } from '../../../actions/service_request';
import Details from '../../Details';
import { debounce } from '../../../utils/common';
import { isIndividualMilestoneStatusInRange, MilestoneSubStatus, MilestoneType } from '../TicketController';
const formName = 'MapFaultyAssetForm';

export default function MapFaultyAsset({ ticket }) {
    const { formButtonLoading } = useSelector((state) => state.loading);
    const defaultValues = { escalation_message: '' };
    const [selectedMilestones, setSelectedMilestones] = useState('');

    const memoizedMilestones = useMemo(() => {
        return ticket.milestones.filter((milestone) => milestone.type === MilestoneType.RMA && isIndividualMilestoneStatusInRange(milestone, MilestoneSubStatus.NEW, MilestoneSubStatus.SIGN_OFF_ACCEPTED));
    }, [ticket.milestones]);

    useEffect(() => {
        if (!selectedMilestones && memoizedMilestones.length > 0) {
            setSelectedMilestones(memoizedMilestones[0].id);
        }
    }, [memoizedMilestones, selectedMilestones]);

    const dispatch = useDispatch();

    const methods = useForm({ defaultValues, mode: 'all' });

    const submit = (formValues) => {
        const payload = {
            asset_id: formValues.asset_id,
            location_id: formValues.location_id,
            ticket_id: ticket.id,
            milestone_id: selectedMilestones
        }
        dispatch(mapFaultyAsset({ payload, formName }));
    };

    return (
        <>
            <div className='px-6 py-2'>
                <RenderMilestones milestones={memoizedMilestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={ticket.agents} />
            </div>
            <Form
                methods={methods}
                onSubmit={submit}
                formName={formName}
                buttonPostion={'justify-end'}
                submitButtonText={'Submit'}
                onCancel={() => dispatch(closeModalAction())}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
            >
                <div className='px-4'>
                    <Input required name={`asset_number`} label="Asset Id/Serial Number"
                        validate={{
                            serialNumberNotInSystem: (value) => {
                                if (value === '') return true;
                                return new Promise(resolve => {
                                    const validateSerialNumber = async () => {
                                        try {
                                            const response = await scogo_apis.inventory.checkAsset({}, {}, {}, { serial_number: value, org_id: ticket.org_id });
                                            const currentMilestoneLocation = ticket.milestones.find(milestone => milestone.id === selectedMilestones);
                                            if (response.status === 201 && response.data.data.location.id !== currentMilestoneLocation?.location_id) {
                                                methods.setValue(`validating`, false);
                                                resolve("Serial Number doesn't at the ticket location.");
                                            } else if (response.status === 201 && response.data.data.id) {
                                                methods.setValue(`asset_id`, response.data.data.id);
                                                methods.setValue(`location_id`, response.data.data.location.id);
                                                methods.setValue(`validating`, false);
                                                resolve(true);
                                            } else {
                                                methods.setValue(`validating`, false);
                                                resolve("Serial Number doesn't exist in the System.");
                                            }
                                        } catch (error) {
                                            console.error("Error checking serial number:", error);
                                            methods.setValue(`validating`, false);
                                            resolve(error?.response?.data?.messages?.[0] || 'Error checking serial number');
                                        }
                                    };

                                    try {
                                        methods.setValue(`validating`, true);
                                        if (!window.debouncedSerialValidation) {
                                            window.debouncedSerialValidation = debounce((callback) => {
                                                callback();
                                            });
                                        }
                                        window.debouncedSerialValidation(validateSerialNumber);
                                    } catch (error) {
                                        console.error("Error in validation:", error);
                                        methods.setValue(`validating`, false);
                                        resolve(error?.response?.data?.messages?.[0] || 'Error validating serial number. Please try again.');
                                    }
                                });
                            },
                        }}
                        isLoading={methods.watch(`validating`)}
                    />
                </div>
            </Form>
        </>
    );
}



